import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { zip } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MenuService, SettingsService, TitleService, ALAIN_I18N_TOKEN } from '@delon/theme';
import { ACLService } from '@delon/acl';
import { TranslateService } from '@ngx-translate/core';
import { I18NService } from '../i18n/i18n.service';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { NzIconService } from 'ng-zorro-antd';
import { ICONS_AUTO } from '../../../style-icons-auto';
import { ICONS } from '../../../style-icons';
import { Router } from '@angular/router';
import { PowerService } from '@core/common/power.service';
import { TenantService } from '@core/common/tenant.service';

/**
 * 用于应用启动时
 * 一般用来获取应用所需要的基础数据等
 */
@Injectable()
export class StartupService {
  constructor(
    iconSrv: NzIconService,
    private menuService: MenuService,
    private translate: TranslateService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private injector: Injector,
    private settingService: SettingsService,
    private aclService: ACLService,
    private titleService: TitleService,
    private httpClient: HttpClient,
    private powerSvc: PowerService,
    private tenantSvc: TenantService,
  ) {
    iconSrv.addIcon(...ICONS_AUTO, ...ICONS);
  }

  load(): Promise<any> {
    // only works with promises
    // https://github.com/angular/angular/issues/15088
    return new Promise(resolve => {
      const tokenData = this.tokenService.get();
      if (!tokenData.token) {
        // token不存在，跳转登陆界面
        this.injector.get(Router).navigateByUrl('/passport/login');
        resolve({});
        return;
      }
      const user: any = {
        name: tokenData.manager_name,
        tenant_name: tokenData.tenant_name,
        avatar: './assets/tmp/img/avatar.jpg',
        // email: 'cipchk@qq.com',
        system_role: tokenData.isadmin,
        token: tokenData.token,
      };
      zip(
        this.httpClient.get(`assets/i18n/${this.i18n.defaultLang}.json`),
        this.httpClient.get('assets/tmp/app-data.json'),
        this.httpClient.get('api/manager/getinfo/' + tokenData.id),
        this.httpClient.get('api/getmenu/' + tokenData.id),
        this.httpClient.get('api/manager/getroles/' + tokenData.id),
        this.httpClient.get('api/power/getallmenu/' + tokenData.id),
      )
        .pipe(
          // 接收其他拦截器后产生的异常消息
          catchError(([langData, appData, loginData, menuData, userRoles, menuInfo]) => {
            resolve(null);
            return [langData, appData, loginData, menuData, userRoles, menuInfo];
          }),
        )
        .subscribe(
          ([langData, appData, loginData, menuData, userRoles, menuInfo]) => {
            // setting language data
            this.translate.setTranslation(this.i18n.defaultLang, langData);
            this.translate.setDefaultLang(this.i18n.defaultLang);
            // this.tokenService.set(userInfo.user);

            // tslint:disable-next-line: triple-equals
            if (loginData.code == 0) {
              // tslint:disable-next-line: triple-equals
              if (loginData.tenant.islock == 1 || loginData.manager.islock == 1) {
                this.tokenService.clear();
                this.injector.get(Router).navigateByUrl('/passport/login');
                resolve({});
                return;
              } else {
                this.tenantSvc.setTenantInfo(loginData.tenant);
              }
            } else {
              this.tokenService.clear();
              this.injector.get(Router).navigateByUrl('/passport/login');
              resolve({});
              return;
            }

            // application data
            const res: any = appData;
            // 应用信息：包括站点名、描述、年份
            this.settingService.setApp(res.app);
            // 用户信息：包括姓名、头像、邮箱地址
            this.settingService.setUser(user);

            // 初始化菜单
            this.menuService.add(menuData);
            this.powerSvc.setMenuPower(menuInfo, userRoles);
            // tslint:disable-next-line: triple-equals
            if (tokenData.isadmin == 999) {
              // ACL：系统管理员-设置权限为全量
              this.aclService.setFull(true);
            } else {
              // ACL: 普通用户-设置角色
              this.aclService.setFull(false);
              this.aclService.setRole(userRoles);
            }
            this.menuService.resume();

            // 设置页面标题的后缀
            this.titleService.default = '';
            this.titleService.suffix = res.app.name;
          },
          () => {},
          () => {
            resolve(null);
          },
        );
    });
  }
}
